import { useLanguage } from "@ihs-widget/utils/hooks/useLanguage";
import { useTranslations } from "../../../../../../../translation/TranslationContext";

export const useFormatDate = (dateString: string) => {
    const language = useLanguage();
    const translations = useTranslations(language);
    
    // Manually parse the date string, assuming format like "2023-10-22"
    const parts = dateString.split(/[-T]/);
    const year = parseInt(parts[0], 10);
    const monthIndex = parseInt(parts[1], 10) - 1; // Months are indexed from 0
    const day = parseInt(parts[2], 10);
    
    const currentYear = new Date().getFullYear();
    
    const monthKeys = [
        'InHouseStats.MonthJanShort', 'InHouseStats.MonthFebShort', 'InHouseStats.MonthMarShort',
        'InHouseStats.MonthAprShort', 'InHouseStats.MonthMayShort', 'InHouseStats.MonthJunShort',
        'InHouseStats.MonthJulShort', 'InHouseStats.MonthAugShort', 'InHouseStats.MonthSepShort',
        'InHouseStats.MonthOctShort', 'InHouseStats.MonthNovShort', 'InHouseStats.MonthDecShort'
    ];
    const month = translations[monthKeys[monthIndex] as keyof typeof translations];

    if (year === currentYear) {
        return `${day} ${month}`;
    }
    return `${day} ${month} ${year}`;
}
